<template>
  <div>
    <div class="page-title-block">
      <mtd-row class="page-head-block">
        <mtd-col :span="24" class="height-full">
          <span class="page-head-title">告警详情</span>
        </mtd-col>
      </mtd-row>
      <mtd-row>
        <mtd-form :model="query_params">
          <mtd-col :span="8">
            <mtd-form-item :label-width="110" prop="params" label="文档名称:">
              <mtd-input placeholder="请输入需要查询的文档名称" style="width: 100%;" v-model="query_params.fileName" clearable/>
            </mtd-form-item>
          </mtd-col>
          <mtd-col :span="8">
            <mtd-form-item :label-width="110" prop="createTime" label="操作时间:">
              <mtd-date-picker type="daterange" placeholder="选择时间" style="width: 100%" value-format="yyyy-MM-dd"
                               v-model="query_params.operate_time" clearable/>
            </mtd-form-item>
          </mtd-col>
          <mtd-col :span="8">
            <mtd-form-item :label-width="110" prop="appealStatus" label="操作类型:">
              <mtd-select style="width: 100%;" v-model="query_params.operateType" clearable>
                <mtd-option label="查看" value="查看"/>
                <mtd-option label="转发" value="转发"/>
                <mtd-option label="下载" value="下载"/>
                <mtd-option label="外发" value="外发"/>
              </mtd-select>
            </mtd-form-item>
          </mtd-col>
          <mtd-col :span="8">
            <mtd-form-item :label-width="110" prop="dataSource" class="margin-bottom-0" label="数据来源">
              <mtd-select v-model="query_params.dataSource" style="width: 100%" @change="list_file_detail" clearable>
                <mtd-option label="学城" value="km"/>
                <mtd-option label="大象" value="xm"/>
              </mtd-select>
            </mtd-form-item>
          </mtd-col>
          <mtd-col :span="8" :offset="8">
            <mtd-form-item :label-width="0" prop="params" class="margin-bottom-0">
              <mtd-button ghost type="primary" style="float: right" @click="list_file_detail">查询</mtd-button>
            </mtd-form-item>
          </mtd-col>
        </mtd-form>
      </mtd-row>
    </div>
    <mtd-row class="page-content-block">
      <mtd-col :span="24">
        <mtd-table :data="alarm_detail_list" size="small">
          <mtd-table-column prop="filename" label="文档名称" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.dataSource === 'xm'">{{ scope.row.filename }}</span>
              <span v-if="scope.row.dataSource === 'km'">
              <a :href="'https://km.sankuai.com/page/'+scope.row.filemd5" target="_blank">{{ scope.row.filename }}</a>
            </span>
            </template>
          </mtd-table-column>
          <mtd-table-column prop="misidObj" label="misID" width="100" show-overflow-tooltip/>
          <mtd-table-column prop="nameObj" label="姓名" width="100" show-overflow-tooltip/>
          <mtd-table-column prop="orgPathNameObj" label="组织架构" width="260" show-overflow-tooltip/>
          <mtd-table-column prop="operateStartTimeObj" label="操作时间" width="140"/>
          <mtd-table-column prop="tag" label="操作行为" width="100"/>
          <mtd-table-column prop="sourceObj" label="数据源" width="80"/>
          <mtd-table-column prop="viewUserCnt" label="数据来源" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.dataSource === 'xm'">大象</span>
              <span v-if="scope.row.dataSource === 'km'">学城</span>
            </template>
          </mtd-table-column>
          <mtd-table-column prop="reportReason" label="举报原因" width="260" show-overflow-tooltip/>
          <mtd-table-column label="操作" width="60">
            <template slot-scope="scope">
              <mtd-button type="text" size="small" @click="report(scope.row)" style="color: #0a70f5;padding-left: 0">
                举报
              </mtd-button>
            </template>
          </mtd-table-column>
        </mtd-table>
        <div style="text-align: right;margin-top: 12px;">
          <mtd-pagination size="small" show-size-changer show-total :total="query_params.tn"
                          :page-size="query_params.sn"
                          :current-page.sync="query_params.cn" @change="change_page"/>
        </div>
      </mtd-col>
    </mtd-row>
    <mtd-modal v-model="reportModal" title="举报" @close="closeModal" width="600px">
      <mtd-form>
        <mtd-form-item label="举报原因:" prop="desc" :label-width="90" class="mtd-form-item-required">
          <mtd-textarea placeholder="请详细填写举报原因" v-model="form_data.reportReason" style="width: 100%;resize: none"
                        rows="5"/>
        </mtd-form-item>
      </mtd-form>
      <div slot="footer" class="demo-modal-footer">
        <mtd-button @click="closeModal">取消</mtd-button>
        <mtd-button type="primary" :loading="submitLoading" @click="submitReason"
                    :disabled="form_data.reportReason.trim() === ''">
          确定
        </mtd-button>
      </div>
    </mtd-modal>
  </div>
</template>

<script>

  import {mapActions} from 'vuex'

  export default {
    name: "alert_detail",
    data() {
      return {
        alarm_detail_list: [],
        reportModal: false,
        submitLoading: false,
        query_params: {
          fileName: '',
          fileNameLike: '',
          operate_time: [],
          operateType: '',
          dataSource: null,
          queryDt: null,
          cn: 1, // 当前页面
          sn: 10, // 每页大小
          tn: 0 // 总条数
        },
        form_data: {
          detailId: null,
          fileMd5: null,
          fileName: null,
          misId: null,
          reportReason: ''
        }
      }
    },
    mounted: function () {
      // 1.首先获取传递的参数
      let filename = this.$route.params.filename;
      let dataSource = this.$route.params.dataSource;
      let queryDt = this.$route.params.queryDt;
      if (filename && filename !== '') {
        this.query_params.fileName = filename;
      }
      if (dataSource && dataSource !== '') {
        this.query_params.dataSource = dataSource;
      }
      if (queryDt && (/^\d{8}$/.test(queryDt))) {
        this.query_params.queryDt = queryDt;
      }
      this.list_file_detail();
    },
    methods: {
      // API方法
      ...mapActions({
        api_list_file_detail: 'api_file_trace_query_file_detail',
        api_file_detail_report: 'api_file_trace_file_detail_report',
      }),
      list_file_detail() {
        if (this.query_params.operate_time.length === 2) {
          this.query_params.operateStartTime = this.query_params.operate_time[0] + " 00:00:00";
          this.query_params.operateEndTime = this.query_params.operate_time[1] + " 23:59:59";
        } else {
          this.query_params.operateStartTime = null;
          this.query_params.operateEndTime = null;
        }
        this.query_params.size = this.query_params.sn;
        this.query_params.page = this.query_params.cn;
        this.api_list_file_detail(this.query_params).then((res) => {
          if (res.code === 0) {
            let {cn, sn, tn, items} = res.data;
            this.alarm_detail_list = items;
            this.query_params.cn = cn;
            this.query_params.sn = sn;
            this.query_params.tn = tn;
          } else {
            this.$mtd.message.error('获取数据失败');
          }
        });
      },
      change_page(current, size) {
        this.query_params.cn = current;
        this.query_params.sn = size;
        this.list_file_detail();
      },
      report(row) {
        this.form_data.detailId = row.id;
        this.form_data.fileMd5 = row.filemd5;
        this.form_data.fileName = row.filename;
        this.form_data.misId = row.misid;
        this.reportModal = true;
      },
      closeModal() {
        this.form_data = {
          detailId: null,
          fileMd5: null,
          fileName: null,
          misId: null,
          reportReason: ''
        };
        this.reportModal = false;
      },
      submitReason() {
        this.api_file_detail_report(this.form_data).then(() => {
          this.$mtd.message.success('举报成功');
          this.closeModal();
          this.list_file_detail();
        });
      }
    }
  }
</script>

<style scoped>
  @import "../../../styles/public.css";
  @import "../../../styles/reset_table.css";

  .page-head-title {
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 20px;
    color: #333333;
    letter-spacing: 0.5px;
    line-height: 28px;
  }

  .search-block {
    background-color: white;
    margin-bottom: 12px;
  }
</style>
